import { useEffect, useRef } from 'react';

/**
 * Similar to useEffect but does not call fn on initial render
 * 
 * @param {() => void} fn 
 * @param {any[]} deps 
 */
const usePostEffect = (fn, deps) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return
    }

    return fn();
  }, deps);
}

export default usePostEffect;